module.exports = __webpack_public_path__ + "img/fb_logo.badc24a9.png";